// extracted by mini-css-extract-plugin
export default {"BackButton":"back-button_BackButton__rzMpC","BackButtonRight":"back-button_BackButtonRight__Lroty","BackButtonLeft":"back-button_BackButtonLeft__-LtUe"};